<div class="p-4 md:p-6">
  <h2 mat-dialog-title class="text-3xl font-bold text-gray-800 mb-4 flex justify-between items-center">
    {{ 'EDIT_SUBSCRIPTION.TITLE' | translate }}
  </h2>

  <mat-dialog-content class="space-y-4">

    <div class="bg-gray-50 p-4 rounded-lg shadow-inner">
      <p class="text-sm text-gray-600">{{ 'EDIT_SUBSCRIPTION.CURRENT_PLAN' | translate }}</p>
      <p class="text-2xl font-semibold text-indigo-600">{{ data.planName }}</p>
    </div>

    <div class="grid grid-cols-2 gap-4 text-sm">

      <!-- DOCU-1042: Während der Testphase wäre "Preis pro Seat: 0,00 €" irreführend —
           es sieht aus, als kostete Professional nichts. Stattdessen die Restlaufzeit. -->
      <div class="p-3 bg-white border border-gray-200 rounded-lg" *ngIf="isTrial">
        <p class="font-medium text-gray-700">{{ 'EDIT_SUBSCRIPTION.TRIAL_DAYS_LEFT' | translate }}</p>
        <p class="text-lg font-bold">{{ trialDaysLeft }}</p>
      </div>

      <div class="p-3 bg-white border border-gray-200 rounded-lg" *ngIf="!isTrial">
        <p class="font-medium text-gray-700">
          {{ data.billingInterval === 'year' ? ('EDIT_SUBSCRIPTION.PRICE_PER_SEAT_YEAR' | translate) : ('EDIT_SUBSCRIPTION.PRICE_PER_SEAT_MONTH' | translate) }}
        </p>
        <p class="text-lg font-bold">
          {{ (data.currentPrice || 0) / 100 | number:'1.2-2' }}€
          <span *ngIf="data.billingInterval === 'year'"></span>
          <span *ngIf="data.billingInterval !== 'year'"></span>
        </p>
      </div>

      <div class="p-3 bg-white border border-gray-200 rounded-lg">
        <p class="font-medium text-gray-700">{{ 'EDIT_SUBSCRIPTION.ACTIVE_USERS' | translate }}</p>
        <p class="text-lg font-bold text-green-600">{{ data.seatCount }}</p>
      </div>

      <div class="p-3 bg-white border border-gray-200 rounded-lg col-span-2"
        *ngIf="data.lookupKey && data.lookupKey !== 'FREE'">
        <p class="font-medium text-gray-700">{{ (isTrial ? 'EDIT_SUBSCRIPTION.TRIAL_ENDS' : 'EDIT_SUBSCRIPTION.NEXT_BILLING') | translate }}</p>
        <p class="text-lg font-bold">
          {{ periodEndDate | date: 'dd.MM.yyyy' }}
        </p>
      </div>

    </div>

    <!-- DOCU-1042: Ohne diesen Hinweis liest jemand "Nächste Abrechnung" und rechnet mit
         einer Abbuchung, obwohl keine Zahlungsdaten vorliegen. -->
    <div *ngIf="isTrial && !isTrialExpired" class="p-3 mt-4 text-center bg-blue-50 border border-blue-200 rounded-lg text-blue-800">
      {{ 'EDIT_SUBSCRIPTION.TRIAL_NOTICE' | translate:{days: trialDaysLeft, date: (periodEndDate | date: 'dd.MM.yyyy')} }}
    </div>

    <div *ngIf="isTrialExpired" class="p-3 mt-4 text-center bg-blue-50 border border-blue-200 rounded-lg text-blue-800">
      {{ 'EDIT_SUBSCRIPTION.TRIAL_EXPIRED_NOTICE' | translate:{date: (periodEndDate | date: 'dd.MM.yyyy')} }}
    </div>

    <div *ngIf="data.willCancelAtPeriodEnd" class="p-3 mt-4 text-center bg-yellow-100 border border-yellow-300 rounded-lg text-yellow-800">
      {{ 'EDIT_SUBSCRIPTION.CANCELED_NOTICE' | translate:{date: (periodEndDate | date: 'dd.MM.yyyy')} }}
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="mt-6 border-t pt-4">

    <button mat-flat-button color="accent" (click)="onModifyClick()">
      {{ (isTrial ? 'EDIT_SUBSCRIPTION.BOOK_NOW' : 'EDIT_SUBSCRIPTION.CHANGE_PLAN') | translate }}
    </button>

    <!-- DOCU-1042: Während der Testphase gibt es kein Stripe-Abo. CancelSubscription in der
         API wirft dann InvalidOperationException — der Button muss weg, nicht nur wirkungslos. -->
    <button *ngIf="data.lookupKey != 'FREE' && !data.willCancelAtPeriodEnd && !isTrial" color="warn" (click)="onCancelClick()" mat-button >
      {{ 'EDIT_SUBSCRIPTION.CANCEL_SUBSCRIPTION' | translate }}
    </button>

    <button (click)="dialogRef.close()" mat-button >
      {{ 'ACTION.CANCEL' | translate }}
    </button>

  </mat-dialog-actions>
</div>
